<template>
  <v-flex xs12 class="secondary pa-2 usersDialog">
    <v-flex v-show="manageUsersDisplay === 'list' && !options.subscriptionSuccess" style="position: relative; width: 100%; height: 100%;">
      <v-flex style="flex: none; font-size: 36px; font-weight: 700; margin-top: 60px" class="primary--text">Users in project <span style="font-weight: 300; padding-left: 50px">{{totalUsers}}</span></v-flex>
      <v-flex mt-3 style="display: flex; align-items: flex-start; flex-direction: column; justify-content: flex-start;">
        <div style="display: flex; align-items: center" @click="manageUsersDisplay = 'addUsers'">
          <v-btn large style="height: 73px; width: 73px; font-size: 28px; margin: 0" fab class="elevation-0 addBtn" outline color="primary highlight--text">+</v-btn>
          <div style="font-size: 18px; font-weight: 700; padding-left: 10px" class="primary--text">Add new user</div>
        </div>
        <v-layout row wrap class="mt-4">
          <v-flex style="flex: none; display: flex; align-items: center; margin-right: 30px; margin-bottom: 30px;flex-grow: 1;flex-basis: 0;">
            <img style="max-width: 73px" src="@/assets/user.png" />
            <div style="padding-left: 10px; height: 100%">
              <v-flex style="font-size: 18px; font-weight: 700;word-break: break-word; min-width: 200px" class="primary--text">{{currentUser.firstName + ' ' + currentUser.lastName}}</v-flex>
              <v-flex style="font-size: 14px;word-break: break-word; min-width: 200px" class="primary--text">{{getUserRole(currentUser.id)}}</v-flex>
              <v-flex style="font-size: 14px;word-break: break-word; min-width: 200px" class="primary--text">(Default)</v-flex>
            </div>
          </v-flex>
          <v-flex style="flex: none; display: flex; align-items: center; margin-right: 20px" v-for="item in organizationAdminsWithoutCurrentUser" :key="item.id" v-if="currentUser && item.id !== currentUser.id">
            <img style="max-width: 73px" src="@/assets/user.png" />
            <div style="padding-left: 10px; height: 100%">
              <v-flex class="primary--text" style="font-size: 18px; font-weight: 700">{{item.firstName + ' ' + item.lastName}}</v-flex>
              <v-flex class="primary--text" style="font-size: 14px">{{getUserRole(item.id)}}</v-flex>
            </div>
          </v-flex>
          <v-flex style="flex: none; display: flex; align-items: center; margin-right: 30px; margin-bottom: 30px;flex-grow: 1;flex-basis: 0;" v-for="(item, index) in selectionUsers" :key="item.id">
            <img style="max-width: 73px" src="@/assets/user.png" />
            <div style="padding-left: 10px; height: 100%">
              <v-flex class="primary--text" style="font-size: 18px; font-weight: 700;word-break: break-word; min-width: 200px">{{item.firstName + ' ' + item.lastName}}</v-flex>
              <v-flex class="primary--text" style="font-size: 14px;word-break: break-word; min-width: 200px">{{getUserRole(item.id)}}</v-flex>
            </div>
            <v-btn small icon :ripple="false" light @click="removeSelectedUser(index)" style="text-align: right; position: relative; padding: 0px; margin: 0px; margin-left: 15px;">
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
          <v-flex style="fflex: none; display: flex; align-items: center; margin-right: 30px; margin-bottom: 30px;flex-grow: 1;flex-basis: 0;" v-for="(item, index) in invitationUsers" :key="item.id" v-if="item.email != ''">
            <img style="max-width: 73px" src="@/assets/user.png" />
            <div style="padding-left: 10px; height: 100%">
              <v-flex class="primary--text" style="font-size: 18px; font-weight: 700;word-break: break-word; min-width: 200px">{{item.email}}</v-flex>
              <v-flex class="primary--text" style="font-size: 14px;word-break: break-word; min-width: 200px">{{item.isAdmin ? 'Administrator' : 'Viewer'}}</v-flex>
            </div>
            <v-btn small icon :ripple="false" light @click="removeInvitedUser(index)" style="text-align: right; position: relative; padding: 0px; margin: 0px; margin-left: 15px;">
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex mt-5 style="display: flex; align-items: center; justify-content: flex-end">
        <v-btn v-if="options.button && options.button === 'subscribe'" @click="subscribe()" class="primary" flat round :ripple="false" style="width: 160px; height: 45px; text-transform: capitalize; font-size: 18px" :loading="options.buttonLoading">{{options.buttonText}}</v-btn>
        <v-btn v-if="options.button && options.button === 'manage'" @click="update()" class="primary" flat round :ripple="false" style="width: 160px; height: 45px; text-transform: capitalize; font-size: 18px" :loading="options.buttonLoading">Update Users</v-btn>
      </v-flex>
    </v-flex>
    <v-flex v-show="manageUsersDisplay === 'addUsers' && !options.subscriptionSuccess" style="position: relative; width: 100%; height: 100%;">
      <v-flex style="flex: none; font-size: 36px; font-weight: 300; margin-top: 60px" class="primary--text" v-if="options.project">Add users to <span style="font-weight: 800">{{options.project.name}}</span></v-flex>
      <v-flex style="flex: none; font-size: 36px; font-weight: 700; margin-top: 60px" class="primary--text" v-else>Add users to Project</v-flex>
      <v-layout row style="margin-top: 60px">
        <v-autocomplete :disabled="organizationUsers.length === 0" color="primary" hide-details solo v-if="getUserOrganization" :items="organizationUsers" v-model="selectedUserIds" label="Search by name" item-text="firstName" item-value="id" multiple small-chips :menu-props="{maxHeight:'auto'}" class="usersSearch">
          <template slot="users" slot-scope="data">
            <v-chip :selected="data.users" :key="JSON.stringify(data.item)" close class="chip--select-multi" style="background-color: #2165FF" @input="data.parent.selectItem([data.users.item])">
              {{ data.item.firstName }} {{ data.item.lastName }}
            </v-chip>
          </template>
          <template slot="item" slot-scope="data">
            <template v-if="typeof data.item !== 'object'">
              <v-list-tile-content v-text="data.item"></v-list-tile-content>
            </template>
            <template v-else>
              <v-list-tile-content>
                <v-list-tile-title v-html="data.item.firstName + ' ' + data.item.lastName"></v-list-tile-title>
                <v-list-tile-sub-title v-html="data.item.email"></v-list-tile-sub-title>
              </v-list-tile-content>
            </template>
          </template>
        </v-autocomplete>
        <v-flex style="flex: none;display: flex; align-items: center; justify-content: center">
          <v-btn :disabled="organizationUsers.length === 0 || selectedUserIds.length === 0" class="primary" @click="saveUsers()" flat round :ripple="false" style="text-transform: capitalize">Add</v-btn>
        </v-flex>
      </v-layout>
      <div v-if="organizationUsers.length === 0" style="font-size: 14px; padding-left: 10px" class="primary--text mt-1">It seems your organization does not have any users yet</div>
      <div v-else style="font-size: 14px; padding-left: 10px" class="primary--text mt-1">Return ↵ to add selection</div>
      <v-divider class="my-5" style="border-color: #97A4D9" v-if="!isViewer"></v-divider>
      <v-flex pb-4 class="text-xs-center primary--text" style="font-size: 24px" v-if="!isViewer">
        Or, <span @click="manageUsersDisplay = 'invite'" style="cursor: pointer">invite a new user to <b>{{getUserOrganization.name}}</b></span>
      </v-flex>
      <div @click="manageUsersDisplay = 'list'" style="height: 45px; display: flex; align-items: center; font-size: 18px; cursor: pointer" class="primary--text"><img src="@/assets/back.png" style="max-height: 15px; margin-right: 10px" />Back</div>
    </v-flex>
    <v-flex v-show="manageUsersDisplay === 'invite' && !options.subscriptionSuccess" style="position: relative; width: 100%; height: 100%;" class="invitationsContainer">
      <v-flex style="flex: none; font-size: 36px; font-weight: 300; margin-top: 60px; margin-bottom: 60px" class="primary--text" v-if="options.project">Invite new users to <span style="font-weight: 800">{{getUserOrganization.name}}</span></v-flex>
      <v-flex xs12 mt-1 v-for="(email, index) in invitationsArray" :key="index">
        <v-layout row style="display: flex; align-items: center">
          <v-text-field style="width: 70%" placeholder="name@example.com" :ref="'userInvitationDialogEmailField_'+index" :rules="[rules.email]" class="round" solo flat v-model="invitationsArray[index].email"></v-text-field>
          <v-flex style="flex: none;display: flex; align-items: center; width: 30%">
            <v-checkbox style="width: 50%; flex: none; padding-top: 15px" :ripple="false" color="primary" class="ml-2 noBorder cbxLabel" label="Admin" v-model="invitationsArray[index].isAdmin" hide-details></v-checkbox>
            <div v-if="index !== 0" style="flex: none;width: 50%; display: flex; align-items: center; justify-content: center; cursor: pointer" @click="invitationsArray.splice(index, 1)"><img src="@/assets/remove.png" style="max-height: 10px" /></div>
          </v-flex>
        </v-layout>
      </v-flex>
      <div @click="addNewEmailInvitationField" style="padding: 30px 0; font-size: 18px; display: flex; align-items: center; cursor: pointer" class="primary--text"><img src="@/assets/add.png" style="width: 22px; height: 22px; margin-right: 5px" />Add another</div>
      <v-flex mt-3 v-show="options.dialogType !== 'users'">
        <div style="font-size: 18px; font-weight: 700">Add to project</div>
        <div>
          <v-autocomplete :disabled="getUserOrganization.projects.length === 0" color="primary" hide-details solo v-if="getUserOrganization" :items="organizationProjects" v-model="selectedProjects" item-text="name" item-value="id" multiple chips :menu-props="{maxHeight:'auto'}" class="projectsSearch" deletable-chips>
            <template slot="projects" slot-scope="projectData">
              <v-chip :selected="projectData.projects" :key="JSON.stringify(projectData.item)" close class="chip--select-multi" style="background-color: #2165FF !important" @input="projectData.parent.selectItem([projectData.projects.item])">
                {{ projectData.item.name }}
              </v-chip>
            </template>
            <template slot="item" slot-scope="projectData">
              <template v-if="typeof projectData.item !== 'object'">
                <v-list-tile-content v-text="projectData.item"></v-list-tile-content>
              </template>
              <template v-else>
                <v-list-tile-content>
                  <v-list-tile-title v-html="projectData.item.name"></v-list-tile-title>
                </v-list-tile-content>
              </template>
            </template>
          </v-autocomplete>
        </div>
      </v-flex>
      <v-flex mt-4 style="display: flex; align-items: center; justify-content: space-between">
        <div @click="manageUsersDisplay = 'list'" style="height: 45px; display: flex; align-items: center; font-size: 18px; cursor: pointer" class="primary--text"><img src="@/assets/back.png" style="max-height: 15px; margin-right: 10px" />Back</div>
        <v-btn class="primary" @click="inviteUsers()" flat round :ripple="false" style="width: 160px; height: 45px; text-transform: capitalize; font-size: 18px" :disabled="selectedProjects.length === 0">Invite</v-btn>
      </v-flex>
    </v-flex>
    <v-flex v-show="options.subscriptionSuccess" style="position: relative; width: 100%; height: 100%; margin-top: 60px;">
      <div style="text-align: left">
        <img src="@/assets/check.png" style="margin-bottom: 20px; max-height: 190px; margin: 0; padding: 0">
        <v-flex xs12 style="font-size: 36px; font-weight: 700" class="primary--text">All set!</v-flex>
        <v-flex xs12 v-if="!isViewer && options.dialogType !== 'users'" style="font-size: 18px;" class="primary--text">You have been successfully subscribed to <b>{{options.project.name}}</b></v-flex>
        <v-flex xs12 v-if="isViewer && options.dialogType !== 'users'" style="font-size: 18px;" class="primary--text">Your have successfully suggested <b>{{options.project.name}}</b> to your admins.</v-flex>
        <v-flex xs12 v-if="options.dialogType === 'users'" style="font-size: 18px;" class="primary--text">Your have successfully updated <b>{{options.project.name}}</b>.</v-flex>
        <v-btn flat round v-if="!isViewer" class="mt-5 primary doneBtn" :ripple="false" @click="complete()">Go to project</v-btn>
        <v-btn flat round v-else class="mt-5 primary doneBtn" :ripple="false" @click="complete()">Done</v-btn>
      </div>
    </v-flex>
  </v-flex>
</template>

<style>
  .usersSearch .v-select__slot label, .projectsSearch{
    font-size: 18px;
    color: #7F8DC6;
  }
  .usersSearch .v-input__slot, .projectsSearch{
    box-shadow: none !important;
    height: 45px;
    margin: 0 !important;
  }
  .usersSearch, .projectsSearch{
    border-radius: 50px;
    border: 1px solid #011E41 !important;
  }
  .usersDialog button:hover:before{
    background-color: transparent;
  }
  .usersDialog button:not(.addBtn){
    height: 45px !important;
    margin: 0 0 0 15px;
  }
  .usersDialog .v-text-field.v-text-field--solo .v-input__control{
    min-height: 36px !important;
    display: block
  }
  .projectsSearch.v-text-field.v-text-field--solo .v-input__control, .usersSearch.v-text-field.v-text-field--solo .v-input__control{
    min-height: 43px !important
  }
  .projectsSearch .v-chip, .usersSearch .v-chip{
    background-color: #2165FF !important;
    color: white !important;
    font-size: 18px
  }
  .usersDialog input{
    padding-bottom: 0
  }
  .usersDialog .v-input__slot{
    background-color: transparent !important;
    border-radius: 50px !important;
  }
  .usersDialog .v-input{
    border-radius: 50px;
    height: 45px;
  }
  .addBtn .v-btn__content{
    font-size: 36px !important
  }
  .usersDialog button:disabled{
    background-color: #B2BBC5 !important;
    color: white !important;
  }
  .usersDialog button:disabled .v-btn__content{
    color: white !important;
  }
  .noBorder.v-input{
    border: none !important;
  }
  .cbxLabel .v-label{
    color: #011E41;
  }
  .cbxLabel{
    height: 60px !important;
    margin-top: 0px !important;
  }
  .invitationsContainer .v-input{
    border: 1px solid #011E41
  }
  .usersDialog .v-text-field__slot input{
    color: #7F8DC6 !important;
    font-size: 18px;
  }
</style>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      rules: {
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          if ((this.invitationsArray.filter(item => { return item.email === value }).length === 0 || this.invitationsArray.findIndex(item => { return item.email === value }) !== this.invitationsArray.length) && (this.getUserOrganization.users.filter(item => { return item.email === value }).length === 0 || this.getUserOrganization.users.find(item => { return item.email === value }).active === false)) {
            return pattern.test(value) || 'Invalid e-mail.'
          } else {
            return 'User email previously added.'
          }
        }
      },
      manageUsersDisplay: 'list',
      selectionUsers: [],
      invitationUsers: [],
      selectedUserIds: [],
      invitationsArray: [
        {
          email: '',
          isAdmin: false
        }
      ],
      selectedProjects: []
    }
  },
  props: {
    options: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters('auth', ['currentUser']),
    ...mapGetters({
      getUserOrganization: 'getUserOrganization',
      getRoleById: 'getRoleById',
      getRoleByName: 'getRoleByName'
    }),
    masterRoleId () {
      if (this.$store.getters['getRoleByName']('MASTER_ROLE')) {
        return this.$store.getters['getRoleByName']('MASTER_ROLE').id
      }
    },
    adminRoleId () {
      if (this.$store.getters['getRoleByName']('ADMIN_ROLE')) {
        return this.$store.getters['getRoleByName']('ADMIN_ROLE').id
      }
    },
    viewerRoleId () {
      if (this.$store.getters['getRoleByName']('VIEWER_ROLE')) {
        return this.$store.getters['getRoleByName']('VIEWER_ROLE').id
      }
    },
    organizationAdminsWithoutCurrentUser () {
      if (this.currentUser && this.getUserOrganization && this.getUserOrganization.users && this.getUserOrganization.users.length > 0) {
        return this.getUserOrganization.users.filter(user => {
          return this.getUserOrganization.organizationUsers.filter(e => Number(this.currentUser.id) !== Number(e.userId) && Number(e.userId) === Number(user.id) && (Number(e.roleId) === Number(this.adminRoleId) || Number(e.roleId) === Number(this.masterRoleId))).length > 0
        })
      } else {
        return []
      }
    },
    isViewer () {
      return this.getUserOrganization.organizationUsers.find(item => { return item.userId === this.currentUser.id }).roleId === this.getRoleByName('VIEWER_ROLE').id
    },
    organizationProjects () {
      var projects = JSON.parse(JSON.stringify(this.getUserOrganization.projects))
      if (this.options.project) {
        projects.push(this.options.project)
      }
      return projects
    },
    organizationUsers () {
      if (this.currentUser) {
        var users = JSON.parse(JSON.stringify(this.getUserOrganization.users))
        var self = this
        var index = users.findIndex(function (user) {
          return user.id === self.currentUser.id
        })
        users.splice(index, 1)
        if (users.length > 0) {
          var inactiveUsers = users.filter(item => { return item.active === false })
          if (inactiveUsers && Array.isArray(inactiveUsers) && inactiveUsers.length > 0) {
            for (var i = 0; i < inactiveUsers.length; i++) {
              var userIndex = users.findIndex(function (user) {
                return user.id === inactiveUsers[i].id
              })
              users.splice(userIndex, 1)
            }
          } else if (inactiveUsers && inactiveUsers.id) {
            var inactiveUserIndex = users.findIndex(function (user) {
              return user.id === inactiveUsers.id
            })
            users.splice(inactiveUserIndex, 1)
          }
        }
        return users
      }
    },
    totalUsers () {
      return this.selectionUsers.length + this.invitationUsers.length + 1
    }
  },
  methods: {
    getUserRole (id) {
      return this.getRoleById(this.getUserOrganization.organizationUsers.find(item => { return item.userId === id }).roleId).displayName
    },
    addNewEmailInvitationField () {
      if (this.$refs['userInvitationDialogEmailField_' + (this.invitationsArray.length - 1)][0].validate(true)) {
        this.invitationsArray.push({email: '', isAdmin: false})
      }
    },
    inviteUsers () {
      this.invitationUsers = []
      for (var f = 0; f < this.invitationsArray.length; f++) {
        if (this.$refs['userInvitationDialogEmailField_' + (f)][0].validate(true)) {
          this.invitationUsers.push(this.invitationsArray[f])
        }
      }
      this.manageUsersDisplay = 'list'
    },
    saveUsers () {
      this.selectionUsers = []
      for (var u = 0; u < this.selectedUserIds.length; u++) {
        var user = this.getUserOrganization.users.find(item => { return this.selectedUserIds[u] === item.id })
        if (user) {
          this.selectionUsers.push(user)
        }
      }
      this.manageUsersDisplay = 'list'
    },
    removeInvitedUser (index) {
      this.invitationUsers.splice(index, 1)
      this.invitationsArray.splice(index, 1)
      if (this.invitationsArray.length === 0) {
        this.invitationsArray.push({email: '', isAdmin: false})
      }
    },
    removeSelectedUser (index) {
      this.selectionUsers.splice(index, 1)
      this.selectedUserIds.splice(index, 1)
    },
    subscribe () {
      var subscriptionObject = {
        selectedUsers: this.selectionUsers.concat(this.organizationAdminsWithoutCurrentUser),
        invitedUsers: this.invitationUsers,
        selectedProjects: this.selectedProjects
      }
      this.$emit('subscribe', subscriptionObject)
    },
    update () {
      var updateObject = {
        selectedUsers: this.selectionUsers,
        invitedUsers: this.invitationUsers,
        selectedProjects: this.selectedProjects
      }
      this.$emit('update', updateObject)
    },
    complete () {
      if (!this.isViewer) {
        var route = 'https://app.dataslicer.io/#/home?projectUuid=' + this.options.project.uuid
        window.open(route, '_blank')
      }
      this.manageUsersDisplay = 'list'
      this.selectionUsers = []
      this.invitationUsers = []
      this.selectedUserIds = []
      this.invitationsArray = [
        {
          email: '',
          isAdmin: false
        }
      ]
      this.selectedProjects = []
      this.$emit('close')
    }
  },
  mounted () {
    if (this.options.project) {
      this.selectedProjects.push(this.options.project.id)
      if (this.options.dialogType && this.options.dialogType === 'users') {
        this.selectionUsers = []
        this.invitationUsers = []
        this.selectedUserIds = []
        this.invitationsArray = [
          {
            email: '',
            isAdmin: false
          }
        ]
        var inactiveUsers = []
        var allUserIds = this.getUserOrganization.organizationUserProjects.filter(item => { return item.projectId === this.options.project.id })
        for (var u = 0; u < allUserIds.length; u++) {
          var user = this.getUserOrganization.users.find(item => { return item.id === allUserIds[u].userId && item.id !== this.currentUser.id })
          if (user) {
            if (user.active) {
              this.selectionUsers.push(user)
              this.selectedUserIds.push(user.id)
            } else {
              inactiveUsers.push({email: user.email, isAdmin: this.getUserOrganization.organizationUsers.find(item => { return item.userId === user.id }).roleId === this.getRoleByName('ADMIN_ROLE').id})
            }
          }
        }
        if (inactiveUsers.length > 0) {
          this.invitationsArray = inactiveUsers
          this.invitationUsers = inactiveUsers
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/appElements/ManageUsers.vue